import React from 'react';
import { ListedFilesForm } from './components/ListedFilesForm';
import { StyledModal } from './styles';
import { UploadScope } from './types';

export const AttachmentUploadModal = ({
  scope,
  limit,
  embedded,
  onClose,
  onUploadComplete,
}: AttachmentUploadModalProps) => {
  return embedded ? (
    <ListedFilesForm
      scope={scope}
      limit={limit}
      onClose={onClose}
      onUploadComplete={onUploadComplete}
    />
  ) : (
    <StyledModal
      title={`Add attachments to this ${scope.parentType.toLowerCase()}`}
      onClose={onClose}
      active
    >
      <ListedFilesForm
        scope={scope}
        limit={limit}
        onClose={onClose}
        onUploadComplete={onUploadComplete}
      />
    </StyledModal>
  );
};

export interface AttachmentUploadModalProps {
  scope: UploadScope;
  limit?: number;
  embedded?: boolean;
  onClose?: () => void;
  onUploadComplete?: () => void;
}
